import { createHttpEndpoint } from '../../utils'

import type {
  GetProduct,
  GetSellerProductDetails,
  PostProductValidationRematchSearch,
  PostProductsGenerateEan,
  PostProductsSellerSearch,
} from './products.types'

/**
 * Retrieves all information about a certain product
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-access-api/definition#tag/Products/operation/get-bm-catalog-products-id}
 */
export const getProduct = createHttpEndpoint<GetProduct>({
  method: 'GET',
  operationId: 'getCatalogProduct',
  path: '/bm/catalog/products/:productId',
})

/**
 * Retrieves all information about a certain product if it is public or if it was created by the seller doing the query.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-access-api/definition#tag/Products/operation/get-bm-catalog-seller-products-id}
 */
export const getSellerProductDetails =
  createHttpEndpoint<GetSellerProductDetails>({
    method: 'GET',
    operationId: 'getSellerProductsSearch',
    path: '/bm/catalog/bo-seller/products/:productId',
  })

/**
 * TODO Add link to API specs when available
 */
export const postProductExport = createHttpEndpoint({
  method: 'POST',
  operationId: 'exportProducts',
  path: '/bm/catalog/product/export',
})

/**
 * Rematch a given product to a target product
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-access-api/definition#tag/Products/operation/post-bm-catalog-products-rematch}
 */
export const postProductRematch = createHttpEndpoint({
  method: 'POST',
  operationId: 'rematchCatalogProduct',
  path: '/bm/catalog/products/:productId/rematch',
})

/**
 * Search products that could be the target of a rematch based on user query and facets
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-access-api/definition#tag/Products/operation/get-bm-catalog-products-search}
 */
export const postProductValidationRematchSearch =
  createHttpEndpoint<PostProductValidationRematchSearch>({
    method: 'POST',
    operationId: 'fetchCatalogProductValidationRematchSearch',
    path: '/bm/catalog/product-validations/rematch/search',
  })

/**
 * Search products that are public or created by the seller doing the query
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-access-api/definition#tag/Products/operation/get-bm-catalog-seller-products-search}
 */
export const postProductsSellerSearch =
  createHttpEndpoint<PostProductsSellerSearch>({
    method: 'POST',
    operationId: 'getSellerProductsSearch',
    path: '/bm/catalog/bo-seller/products/search',
  })

/**
 * Generate a fake EAN
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-access-api/definition#tag/Products/operation/post-bm-catalog-products-generate-ean}
 */
export const postProductsGenerateEan =
  createHttpEndpoint<PostProductsGenerateEan>({
    method: 'POST',
    operationId: 'generateProductEan',
    path: '/bm/catalog/products/generate-ean',
  })
